// Shared helpers for rendering competency / sub-competency labels consistently
// across CompetencyOptions, SubCompetencyOptions, and CategoryTabs.
//
// These intentionally mirror the logic already inlined (twice) in
// CompetencyOptions.filterZZZ / SubCompetencyOptions.filterZZZ. Extracted here
// so CategoryTabs can produce byte-identical tab labels to the dropdowns
// without a third copy-paste of the same function.

/**
 * Strips the manual sort-order prefixes ("ZZZ_" / "AAA_") that the
 * underlying data uses to force alphabetical ordering. Same behavior as
 * CompetencyOptions.filterZZZ / SubCompetencyOptions.filterZZZ.
 */
export const filterZZZ = label => {
  if (label === undefined || label === null) return ''
  const str = label.toString()
  const prefix = str.substring(0, 4)
  if (prefix === 'ZZZ_' || prefix === 'AAA_') {
    return str.substring(4, str.length)
  }
  return str
}

/**
 * Returns a NEW array of company values sorted by valueDesc, matching the
 * sort CompetencyOptions applies in render() (which mutates the array it's
 * given in place - we avoid that here since this reads directly from Redux
 * state and mutating a state array in place is its own hazard).
 *
 * Also defensively handles the known reducer edge case where
 * companyValues can come back `undefined` (see getCompanyValues' malformed
 * empty-state dispatch, which sets `pldpTasks: []` instead of
 * `companyValues: []`).
 */
export const getSortedCompanyValueLabels = companyValues => {
  const values = Array.isArray(companyValues) ? companyValues.slice() : []
  values.sort((a, b) => {
    if (a.valueDesc < b.valueDesc) return -1
    if (a.valueDesc > b.valueDesc) return 1
    return 0
  })
  return values
}